import { requestGet, requestPost } from '@/utils/request';

const api = {
	LIST: '/member/user_cashout_list',
	ADD: '/member/user_cashout_add',
};

export async function userCashoutList(queryParams) {
	return requestGet(api.LIST, queryParams);
}

export async function userCashoutAdd(form) {
	return requestPost(api.ADD, form);
}
